import { useState, useEffect } from 'react';
import '../styles/cookie_banner.css';

const STORAGE_KEY = 'cookie_consent';

export const analyticsAllowed = () => localStorage.getItem(STORAGE_KEY) === 'all';

const initMetrika = () => {
  if (window.ym) return;
  const m = window; const e = document; const t = 'script';
  const r = 'https://mc.yandex.ru/metrika/tag.js?id=110047868'; const i = 'ym';
  m[i] = m[i] || function() { (m[i].a = m[i].a || []).push(arguments); };
  m[i].l = 1 * new Date();
  const k = e.createElement(t);
  const a = e.getElementsByTagName(t)[0];
  k.async = 1; k.src = r;
  a.parentNode.insertBefore(k, a);
  window.ym(110047868, 'init', { webvisor: true, clickmap: true, ecommerce: 'dataLayer', accurateTrackBounce: true, trackLinks: true });
};

// VK Реклама (Top.Mail.Ru) — читает события из того же window.dataLayer,
// что и Google Analytics/Яндекс.Метрика выше (переменная называется "dataLayer" — совпадает по умолчанию).
const initVkPixel = () => {
  if (document.getElementById('tmr-code')) return;
  window._tmr = window._tmr || [];
  window._tmr.push({ id: '3777764', type: 'pageView', start: (new Date()).getTime() });
  const ts = document.createElement('script');
  ts.type = 'text/javascript';
  ts.async = true;
  ts.id = 'tmr-code';
  ts.src = 'https://top-fwz1.mail.ru/js/code.js';
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(ts, s);
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      setVisible(true);
    } else if (consent === 'all') {
      initMetrika();
      initVkPixel();
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'all');
    setVisible(false);
    initMetrika();
    initVkPixel();
    if (window.gtag) window.gtag('consent', 'update', {
      analytics_storage:  'granted',
      ad_storage:         'denied',
      ad_user_data:       'denied',
      ad_personalization: 'denied',
    });
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, 'necessary');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      <div className="cookie-overlay" />
      <div className="cookie-banner">
      <span className="cookie-banner-emoji">🍪</span>
      <div className="cookie-banner-text">
        <strong>Угощайтесь печеньками!</strong>
        <p>
          Мы используем cookie-файлы — нет, не те что с шоколадной крошкой, а те что помогают
          сайту работать и нам понимать, что вам интересно.{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer">Подробнее</a>
        </p>
      </div>
      <div className="cookie-banner-actions">
        <button className="cookie-btn cookie-btn--accept" onClick={accept}>
          Съесть все 🍪
        </button>
        <button className="cookie-btn cookie-btn--decline" onClick={decline}>
          Только необходимые
        </button>
      </div>
    </div>
    </>
  );
};

export default CookieBanner;
